export class Status {
  statusId: number = -1;
  statusDescription: string;
  soundFile: string;
  updateDate: Date;

  constructor(json?: any) {
    if (!json) {
      return;
    }

    this.statusId = json.statusId;
    this.statusDescription = json.statusDescription;
    if (!!json.soundFile) {
      this.soundFile = json.soundFile ;
    }
    this.updateDate = json.updateDate;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/models/Status.ts